import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheck, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo.svg';
import Header from '../components/Header';

const ReportDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { event, mcq_responses, programming_responses, category_wise, consolidated_marks } = location.state.data;
    const { candidateId, candidateName } = location.state;

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/'); // Redirect to login page
    };


    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            <Header headerTitle={"Report Details"}/>

            {/* Main Content */}
            <main className="flex-grow p-8">
                {/* Event Details */}
                <div className="bg-white shadow-md rounded-lg p-6 mb-6">
                    <h2 className="text-2xl font-semibold mb-4">{event.event_name}</h2>
                    <h5 className="text-lg font-semibold">Candidate ID: {candidateId}</h5>
                    <h5 className="text-lg font-semibold">Candidate Name: {candidateName}</h5>
                    <p>Date: {new Date(event.event_date).toLocaleDateString()}</p>
                    <p>Passkey: {event.passkey}</p>
                </div>

                {/* MCQ Responses */}
                <div className="mb-8">
                    <h3 className="text-xl font-semibold mb-4">MCQ Responses</h3>
                    <div className="space-y-4">
                        {mcq_responses.map((mcq, index) => (
                            <div key={mcq.question_id} className="flex items-start gap-4 border-b pb-2">
                                <span className="font-medium">{index + 1}.</span>
                                <div className="flex-grow">
                                    <p className="text-gray-700">{mcq.question_text}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    {mcq.is_correct ? (
                                        <FaCheck className="text-green-500" />
                                    ) : (
                                        <FaTimes className="text-red-500" />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Programming Responses */}
                <div className="mb-8">
                    <h3 className="text-xl font-semibold mb-4">Programming Responses</h3>
                    {programming_responses.map((prog) => (
                        <div key={prog.question_id} className="space-y-3">
                            <p className="font-medium">{prog.question_text}</p>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-sm font-semibold mb-2">Submitted Code:</h4>
                                <pre className="bg-gray-800 text-white p-4 rounded overflow-x-auto">
                                    <code>{prog.submitted_code}</code>
                                </pre>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-sm font-semibold mb-2">Compilation Message:</h4>
                                <p className="text-gray-700">{prog.compilation_message}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Category-wise Results */}
                <div className="mb-8">
                    <h3 className="text-xl font-semibold mb-4">Category-wise Results</h3>
                    <div className="space-y-4">
                        {category_wise.map((category, index) => (
                            <div key={index} className="flex justify-between bg-gray-50 p-4 rounded-lg">
                                <p className="font-medium">{category.question_category}</p>
                                <p className="text-lg">{category.correct_answers} / {category.total_attempted}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Consolidated Marks */}
                <div>
                    <h3 className="text-xl font-semibold mb-4">Results Summary</h3>
                    <div className="space-y-4">
                        <div className="flex justify-between bg-gray-50 p-4 rounded-lg">
                            {/* <div> */}
                                <p className="font-medium">MCQ Score</p>
                                <p className="text-lg">{consolidated_marks.total_mcq_correct} / {consolidated_marks.total_mcq_attempted}</p>
                            {/* </div> */}
                            {/* <div>
                                <p className="font-medium">Average Execution Time:</p>
                                <p className="text-lg">{consolidated_marks.avg_execution_time}s</p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-red-500 text-white p-4 text-center">
                © 2024 vThink Global Technologies Pvt. Ltd. All Rights Reserved
            </footer>
        </div>
    );
};

export default ReportDetails; 